import { type TComment, getAudioCommentsUrl, withQuery } from '@core/api'
import { httpClient } from '@core/http-client'

/**
 * Fetch the flat comment list for an audio track. Replies are embedded eagerly via `expand=replies`
 * (nextjs parity — there is no reply pagination). Public read: works without a session.
 */
export const getAudioComments = (id: string, signal?: AbortSignal) => {
    return httpClient
        .get(withQuery(getAudioCommentsUrl(id), { expand: 'replies' }), { signal })
        .json<TComment[]>()
}
